import { Route } from "react-router-dom";
import PaymentSuccessPage from "./SuccessPage";
import PaymentCancelPage from "./CancelPage";

export default (
  <Route path="/payments">
    <Route path="success" element={<PaymentSuccessPage />} />
    <Route path="cancel" element={<PaymentCancelPage />} />
  </Route>
);


